import React, { Component } from "react";
import { Nav, Row, Col, Button, Form } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

import 'containers/common/Detail.css';
import "containers/common/List.css";
import { API } from "aws-amplify";
import ReactTable from "react-table";
import 'react-table/react-table.css';
import DatePicker from "react-datepicker";
//import Moment from "moment";

export default class SLMAddressList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            addresses: [],
            filter: {}
        };

        
       
        this.deleteAddress = this.deleteAddress.bind(this);
        this.handleDeleteAddress = this.handleDeleteAddress.bind(this);
    }
    

    async componentDidMount() {
        console.log("In AddressList componentDidMount");
        if (!this.props.isAuthenticated) { // if false
            return;
        }

       
        
        // try {

        //     const addresses = await this.getAddresses(this.props.filter);
        //     this.setState({ addresses });
        // } catch (e) {
        //     alert(e);
        // }

        this.setState({ isLoading: false });      

    }
        async componentDidUpdate(prevProps) {
        console.log("ComponentDidUpdate");


        // if (prevProps.filter !== this.props.filter) {
        //     const addresses = await this.getAddresses(this.props.filter);
        //     this.setState({ addresses });
        // }
    }


    getAddresses(filter) {
        console.log("Inside getaddresses()");

        console.log(filter);
        
        //  this.setState({ searching : true });

          return API.get("colin", "/slmaddresses", {'queryStringParameters': filter});
      
    }
    

    deleteAddress(addressid) {
        return API.del("colin", "/slmaddress", { 'queryStringParameters': addressid });

    };
    
    handleDeleteAddress = async event => {
        
    
        var r = window.confirm("Are you sure you want to delete this address?");
        if (r === true) {

            //Delete property
            await this.deleteAddress(event);

            //New search for addresses using the existing filters
            this.setState({ isLoading: true });
        
            let addresses = await this.getAddresses(this.props.filter);        
            
            this.setState({ addresses });
            this.setState({ isLoading: false });
            
            
        };
    };


    
    handleInputChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.setState({data});
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = val;
        data[cellInfo.index].modified = true;
        this.setState({data});
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.setState({data});
    };

    handleDateChange = (cellInfo, event) => {
        let addresses = [...this.props.data];
        addresses[cellInfo.index][cellInfo.column.id] = new Date(event);
        addresses[cellInfo.index].modified = true;
        this.setState({addresses});

    }

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];


        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        // onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                // onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    // onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }



    renderAddressList(addresses) {
        const columns = [
            {
                id: 'selected',
                Header: '',
                maxWidth: 60,
                accessor: 'selected',
                Cell: this.renderEditable,
                style: { textAlign: "center" }
            },
            {
                id: 'address_id',
            Header: 'CoLin ID',
            maxWidth: 80,
                accessor: 'address_id' ,
                Cell: e => <LinkContainer to={ {pathname: `/slmaddresses/${e.value}`, state: {data: this.props.data.filter((a) => { if(a.selected){return true;}else{return false;}} ).map(a => a.address_id)}}}><a>{e.value}</a></LinkContainer>,


            },
            {
                id: 'hard_sequence',
            Header: 'PIMs ID',
            maxWidth: 80,
                accessor: 'hard_sequence' 

            }, {
                id: 'building_name',
                Header: 'Building Name',
                accessor: 'building_name',
                style: { 'white-space': 'unset' } 

            }
            // , {
            //     id: 'floor_unit',
            //     Header: 'Unit No.',
            //     accessor: 'floor_unit',
            //     maxWidth: 80,
            //     style: { 'white-space': 'unset' } 

            // }
         , {
               
                id: 'street_address',
                Header: 'Street Address',                                
                accessor: d=> {
                    return d.street_address
                },
                style: { 'white-space': 'unset' } 

            },  {
                id: 'suburb',
                Header: 'Suburb',
                accessor: 'suburb',
                style: { 'white-space': 'unset' } 

            }, {
                id: 'state_code',
                Header: 'State',
                maxWidth: 80,
                accessor: 'state_code'

            }, {
                id: 'postcode',
                Header: 'Postcode',
                maxWidth: 80,
                accessor: 'postcode'

            }, {
                id: 'cityscope_reference',
                Header: 'Cityscope Ref.',
                accessor: 'cityscope_reference'

            }, {
                id: 'lot_plan',
                Header: 'Lot Plan',
                maxWidth: 80,
                accessor: 'lot_plan'

            }, {
                id: 'title_reference',
                Header: 'Title Ref.',
                maxWidth: 80,
                accessor: 'title_reference'

            }
            , {
                id: 'sold_count',
                Header: 'Sold',
                maxWidth: 60,
                accessor: 'sold_count',
                style: { textAlign: "center" }

            }
            , {
                id: 'sale_count',
                Header: 'For Sale',
                maxWidth: 60,
                accessor: 'sale_count',
                style: { textAlign: "center" }

            }
            , {
                id: 'leased_count',
                Header: 'Leased'
                ,maxWidth: 60,
                accessor: 'leased_count',
                style: { textAlign: "center" }

            }, {
                id: 'lease_count',
                Header: 'For Lease'
                ,maxWidth: 60,
                accessor: 'lease_count',
                style: { textAlign: "center" }

            }
            // ,
            // {
            //     Header: '',
            //     accessor: 'address_id',
            //     Cell: row => <button onClick={(e) => this.handleDeleteAddress(row.value,e)}>Delete</button>
            // }
        ]

        if (!addresses) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={addresses}
                    columns={columns}
                    defaultPageSize={50}
                    className="-striped -highlight"
                    sortable={false}
                />
            )
        }



    }

    selectAll = event =>{
        let addresses = [...this.props.data];
        for(var i=0;i<addresses.length;i++){
            addresses[i].selected=true;
        }
        this.setState({addresses});
    }

    deselectAll = event =>{
        let addresses = [...this.props.data];
        for(var i=0;i<addresses.length;i++){
            addresses[i].selected=false;
        }
        this.setState({addresses});
    }

    
    renderAddresses() {
        return (
            <div className="addresses">
                     <Row >
                <Col className="text-left" >
                <Nav className="justify-content-start"  >
                             <Nav.Item  >
                            <Button variant="primary" type="button" size="sm" onClick={this.selectAll}>Select All</Button>{" "}
                           </Nav.Item> <Nav.Item  >
                             <Button variant="primary" type="button" size="sm" onClick={this.deselectAll}>Deselect All</Button>{" "}
                             </Nav.Item> 
                             
                           
                            
                                
                                </Nav>
                        </Col>
                       
                        <Col className="text-right" sm={4} md={3} lg={2}>
                        {this.props.search_count>0 && <LinkContainer to={`/slmaddresses/new`}>
                                <Button variant="primary" type="button" size="sm" >Add New</Button>
                                </LinkContainer>}
                        </Col>
                    </Row>
                    
                     <Row>
                        <Col><b>{this.props.data ? this.props.data.length: "0" } of {this.props.data ? this.props.data.length>0 ? this.props.data[0].result_count: "0":"0"} records returned.</b></Col>
                    </Row>
                    
                    <Row>
                        <Col sm={12} md={12} lg={12}>
                            {!this.state.isLoading && this.renderAddressList(this.props.data)}
                        </Col>
                    </Row>

            </div>
        );
    }
  render() {
    return (

        <div className="AddressList">
            {this.props.isAuthenticated ? this.renderAddresses() : console.log("error)")}
        </div>
    );
  }
}
